import React from 'react';
import Page from '../core/screens/Page';
import '../css/screens/TrialServiceHomePage.scss';
import Link from '../css/ui/Link';
import Grid from '../responsive/Grid';
import Button from '../ui/Button';
import { ArrowHalfDown, ArrowRight } from '../ui/Vectors';

export default class TrialServiceHomePage extends Page {
	closeAll()
	{
		let items = this.container.querySelectorAll('.caseItem.open');
		items.forEach((e, i)=>{
			e.classList.remove('open');
		});
	}

	render() {
		console.log(this.props.content);
		return this.wrap(
			<React.Fragment>
				<div className="header padding">
					<Grid cols={2} breakpoints={{small: {cols: 4}}}>
						<h1>{this.props.content.title}</h1>
					</Grid>
					<Grid cols={2} breakpoints={{small: {cols: 4}}}>
						<div className='text'>{this.props.content.text}</div>
					</Grid>
				</div>
				<Grid cols={4} className='banners'>
					{this.props.content?.items?.map((item, i)=>{
						return (<CaseBanner content={item} index={i} key={'banner' + i}></CaseBanner>)
					})
					}
				</Grid>
				<div className='seeall'>
					<Link {...this.props.content.allbutton}>{this.props.content.allbutton.label} <ArrowRight></ArrowRight></Link>
				</div>
			</React.Fragment>
		);
	}
}

class CaseBanner extends React.Component<{content, index}>
{
	render()
	{
		return (
			<Link to={'trial-service-' + (this.props.index + 1)}>
				<div className='caseBanner'>
					<div>
						<img {...this.props.content.home_banner.image}></img>
					</div>
					<div className="description">CO-CREATION　|　{this.props.content.subtitle}</div>
					<div className='title'>{this.props.content.home_banner.title}</div>
				</div>
			</Link>
		);
	}
}
